module.exports = __webpack_public_path__ + "static/media/meme_13.708ea31d.png";